import type { ReactNode } from 'react';
import { Paper, artStyle } from './parts';

/** An office copier with Paige's app on its touch panel and a page going in through the feeder. */
export function CopierArt({ width = 280 }: { width?: number }): ReactNode {
  return (
    <svg
      className="scan-art"
      viewBox="0 0 280 180"
      style={artStyle(width)}
      aria-hidden="true"
      focusable="false"
    >
      <path className="sa-shade" d="M82 48 L92 22 H156 L164 48 Z" strokeLinejoin="round" />
      <Paper x={104} y={10} w={36} h={34} tone={1} className="sa-float" />
      <rect className="sa-body" x="66" y="46" width="132" height="22" rx="6" />
      <rect className="sa-body" x="60" y="66" width="144" height="96" rx="9" />
      <path className="sa-shade" d="M60 86 H36 l6 16 h18 Z" strokeLinejoin="round" />
      <Paper x={38} y={78} r={-4} w={22} h={16} tone={2} lines={false} />
      <path className="sa-ink" d="M76 112h112M76 138h112" opacity="0.45" />
      <path className="sa-ink" d="M122 124h20M122 150h20" />
      <path className="sa-shade" d="M198 54 l18 -6 v20 l-18 4 Z" strokeLinejoin="round" />
      <g transform="rotate(-10 236 46)">
        <rect className="sa-body" x="208" y="26" width="58" height="40" rx="6" />
        <rect className="sa-accent" x="214" y="32" width="46" height="28" rx="3" />
        <path className="sa-on-accent" d="M221 46h8M233 46h8M245 46h8" />
      </g>
    </svg>
  );
}
